// Element UI 插件(按需引入)
// 迁移自 main.js 中的 ElementUI 相关注册,由全量引入改为按需引入:
// 只注册项目实际用到的组件,配合 nuxt.config.js 中 babel-plugin-import
// 实现 JS/CSS 按需打包,减小 vendor 体积,加快页面(尤其是 window.open 新 tab)打开速度。
// 注意:新增页面用到新的 el- 组件时,需要在此处补充 import 和注册。

import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'

import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import {
  Button,
  Input,
  Form,
  FormItem,
  Dialog,
  Select,
  Option,
  Radio,
  RadioGroup,
  Pagination,
  Upload,
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Descriptions,
  DescriptionsItem,
  Switch,
  Rate,
  Progress,
  Cascader,
  Badge,
  Tabs,
  TabPane,
  Checkbox,
  Image,
  DatePicker,
  Carousel,
  CarouselItem,
  Timeline,
  TimelineItem,
  Link,
  Tag,
  Popover,
  InputNumber,
  Message,
  MessageBox,
  Notification,
  Loading
} from 'element-ui'
// 全局基础样式:icon 字体、fade/zoom 过渡动画,组件内部依赖,必须保留
import 'element-ui/lib/theme-chalk/base.css'

const components = [
  Button,
  Input,
  Form,
  FormItem,
  Dialog,
  Select,
  Option,
  Radio,
  RadioGroup,
  Pagination,
  Upload,
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Descriptions,
  DescriptionsItem,
  Switch,
  Rate,
  Progress,
  Cascader,
  Badge,
  Tabs,
  TabPane,
  Checkbox,
  Image,
  DatePicker,
  Carousel,
  CarouselItem,
  Timeline,
  TimelineItem,
  Link,
  Tag,
  Popover,
  InputNumber
]

components.forEach((component) => {
  Vue.use(component)
})

Vue.component(CollapseTransition.name, CollapseTransition)

// 服务类组件(element-ui 默认语言即 zh-CN,与原全量引入时显式设置 zh-CN 效果一致)
Vue.use(Loading.directive) // v-loading 指令
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
